// frontend/src/pages/public/NotFoundPage.jsx
import React from "react";
import Seo from "../../marketing/Seo";
import { Container, Button } from "../../marketing/ui";

export default function NotFoundPage() {
  return (
    <Container className="py-24 text-center sm:py-32">
      <Seo title="Page not found" description="The page you're looking for doesn't exist." />
      <p className="text-7xl font-bold tracking-tight text-brand-600">404</p>
      <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900">Page not found</h1>
      <p className="mx-auto mt-3 max-w-md text-gray-600">
        The page you're looking for doesn't exist or may have moved.
      </p>
      <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
        <Button to="/" size="lg">Back to home</Button>
        <Button to="/docs" size="lg" variant="secondary">Browse the docs</Button>
      </div>
    </Container>
  );
}
